<div ngbDropdown class="d-inline-block" >
  <button  type="button" ngbDropdownToggle class="btn btn-outline-secondary">
    {{ getLang(current())?.label }}
</button>

  <div ngbDropdownMenu>
    <button
      type="button" 
      ngbDropdownItem
      *ngFor="let l of languages"
      [class.active]="l.code === current()"
      (click)="changeLang(l.code)">
      {{ l.name }}
    </button>
  </div>
</div>
